<div>
  <div class="text-center text-lg-right">
    <button class="btn btn btn-sm btn-primary btn-square" style="float: left;" id="addEmployeeBackBtn" type="button"
      (click)="onBack()">Back</button>
    <button class="btn btn-sm m-1 btn-outline-primary" printSectionId="print-section" ngxPrint
      (click)="saveInvoicePrint()" [useExistingCss]="true">
      <fa-icon [icon]="['fas', 'print']"></fa-icon> Print
    </button>
  </div>
  <div class="card card-box" id="print-section">
    <div class="card-body">
      <div>
        <div class="text-center text-lg-center mb-2" style="background: black;
                color: white;
                padding-top: 5px;
                padding-bottom: 2px;
    border-radius: 5px;">
          INVOICE
        </div>

        <div class="row">
          <div class="col-7">
            <div class="mb-1" style="color: black;   font-weight: 600;
                        font-size: 0.7rem; " *ngIf="invoiceData && invoiceData[0]?.CURRENCY_FLAG == 'CAD'">
              <span *ngIf="invoiceData[0]?.STATION == 'YVR236' ">
                {{invoiceData[0]?.TAX_LABEL_DESCRIPTION}}
              </span> <br />
              Alliance Ground International Canadian Company, d.b.a. Airport Butler <br />
              <p class="">
                Vancouver International Airport <br />
                Richmond, B.C. Canada, V7B 1W2 <br />
                P: 855.822.9868 <br />
                <span *ngIf="invoiceData[0]?.STATION != 'YVR236' "> F: 604.244.9882 </span>
              </p>
              <div class="mb-2" style="color: black;
                            font-weight: 500;
                            font-size: 12px;">
                Remit To: APO Box 32421 Domestic Terminal
                Richmond, <br /> BC V7B 1W2 Canada
              </div>

            </div>
            <div class="mb-1" style="color: black;font-weight: 600;font-size: 12px;"
              *ngIf="invoiceData && invoiceData[0] && invoiceData[0]?.CURRENCY_FLAG == 'USD'">
              Alliance Ground International, d.b.a. Airport Butler <br />
              <p class="">

                9130 S. Dadeland Blvd, Two Datran Center <br />
                Suite 1801 Miami, Florida, 33156 <br />
                P: 855.822.9868

              </p>

              <!-- <div class="mb-2" style="color: black;
                                font-weight: 500;
                                font-size: 12px;">
                Remit To: P.O. Box 934054 Atlanta, GA 31193-4054 USA
              </div> -->
            </div>
          </div>
          <div class="col-5">
            <div class="align-items-right p-2 pb-3">
              <img style="height: 5rem;" alt="..." class="w-65 mx-auto d-block img-fluid"
                src="assets/img/logo__airport-butler-dark.svg">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-7">

            <div class="mb-2 font-size-xs" *ngIf="invoiceData[0]?.RES_TYPE != 'Retail-Web'">
              <b> Bill To : </b>
            </div>
            <div class="mb-1" style="color: black;
                        font-weight: 500;
                        font-size: 12px;" *ngIf="invoiceData[0]?.RES_TYPE != 'Retail-Web'">
              {{invoiceData[0]?.COMPANY_NAME}}
              <br />
              {{invoiceData[0]?.ADDRESS1}}
              <br />
              <span *ngIf="invoiceData[0]?.CITY && invoiceData[0]?.STATE && invoiceData[0]?.ZIPCODE">
                {{invoiceData[0]?.CITY}}, {{invoiceData[0]?.STATE}} {{invoiceData[0]?.ZIPCODE}} </span>
              <span *ngIf="!invoiceData[0]?.CITY && !invoiceData[0]?.STATE && !invoiceData[0]?.ZIPCODE"> &nbsp; </span>
              <span *ngIf="invoiceData[0]?.CITY && invoiceData[0]?.STATE && !invoiceData[0]?.ZIPCODE">
                {{invoiceData[0]?.CITY}}, {{invoiceData[0]?.STATE}} </span>
              <span *ngIf="invoiceData[0]?.CITY && invoiceData[0]?.ZIPCODE && !invoiceData[0]?.STATE">
                {{invoiceData[0]?.CITY}}, {{invoiceData[0]?.ZIPCODE}} </span>
              <span *ngIf="invoiceData[0]?.CITY && !invoiceData[0]?.STATE && !invoiceData[0]?.ZIPCODE">
                {{invoiceData[0]?.CITY}} </span>
              <span *ngIf="!invoiceData[0]?.CITY && (invoiceData[0]?.STATE || invoiceData[0]?.ZIPCODE)">
                {{invoiceData[0]?.STATE}} {{invoiceData[0]?.ZIPCODE}} </span>
            </div>
          </div>

          <div class="col-5">
            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="">Purchase Order #</span>
              </div>
              <div class="col mr-4 list-right-text">
                {{invoiceData[0]?.PURCHASE_ORDER}}
              </div>
            </div>


            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="">Invoice #</span>
              </div>
              <div class="col mr-4 list-right-text">
                {{invoiceData[0]?.INVOICE_RECEIPT_ID}}
              </div>
            </div>
            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="">Invoice Date</span>
              </div>
              <div class="col mr-4 list-right-text">
                {{getDateFormat(invoiceData[0]?.INVOICE_RECEIPT_DATE)}}
              </div>
            </div>
            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="">Reservation #</span>
              </div>
              <div class="col mr-4 list-right-text">
                {{invoiceData[0]?.RESID}}
              </div>
            </div>
            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="">Event Date</span>
              </div>
              <div class="col mr-4 list-right-text">
                {{getTimeFormat(invoiceData[0]?.STARTDT)}}
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive mt-2">
          <table class="table table-bordered font-size-xs">
            <thead>
              <tr>
                <th class="tx-right">Quantity</th>
                <th class="tx-right">Description</th>
                <th class="tx-right">Unit Charge</th>
                <th class="tx-right">Ext.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let invoice of miscServices">
                <td class="tx-center">{{invoice.QUANTITY}}</td>
                <td class="tx-right">
                  <span class="text-uppercase"> {{invoice.LONGDESC}}
                    <span class="text-capitalize"
                      *ngIf="invoice.LONGDESC == 'MiscService' &&  (invoice.SLNOTES != null && invoice.SLNOTES != '') ">
                      ( {{invoice.SLNOTES}} ) </span>
                    <span class="text-capitalize"
                      *ngIf="invoice.LONGDESC == 'MiscService' && (invoice.SLNOTES == null && invoice.SLNOTES == '') ">
                      &nbsp; </span>
                  </span>
                </td>
                <td class="tx-right text-uppercase">${{ (invoice.UNITCOST ).toFixed(2)}}</td>
                <td class="tx-right">${{ (invoice.AMOUNT * invoice.QUANTITY ).toFixed(2)}}</td>
              </tr>
              <!-- <tr *ngIf="invoiceData[0]?.TRANSACTION_SUBTOTAL != subTotal">
                                <td class="tx-center"> 1</td>
                                <td class="tx-center">Misc Service</td>
                                <td class="tx-center">${{(invoiceData[0]?.TRANSACTION_SUBTOTAL) - subTotal }}</td>
                                <td class="tx-center">${{(invoiceData[0]?.TRANSACTION_SUBTOTAL) - subTotal }}</td>
                            </tr> -->
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr *ngIf="miscServices.length == 1 ">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr *ngIf="miscServices.length == 1 || miscServices.length == 2">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr *ngIf="miscServices.length == 1 || miscServices.length == 2|| miscServices.length == 3">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr
                *ngIf="miscServices.length == 1 || miscServices.length == 2 || miscServices.length == 3|| miscServices.length == 4">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr
                *ngIf="miscServices.length == 1  || miscServices.length == 2 || miscServices.length == 3|| miscServices.length == 4 || miscServices.length == 5">
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-7">
            <!-- <div class="rounded p-3 bg-secondary mb-4">
                        <div class="text-uppercase text-primary mb-2 font-size-xs">
                            Notes
                        </div>
                        <p class="font-size-sm mb-0">
                            Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur
                        </p>
                    </div> -->
          </div>
          <div class="col-5">
            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="">Subtotal</span>
              </div>
              <div class="col mr-4 list-right-text">
                ${{ (invoiceData[0]?.TRANSACTION_SUBTOTAL).toFixed(2)}}
              </div>
            </div>
            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="" *ngIf="invoiceData && invoiceData[0]?.CURRENCY_FLAG == 'USD'">Tax</span>
                <span class=""
                  *ngIf="invoiceData && invoiceData[0]?.CURRENCY_FLAG == 'CAD'">{{invoiceData[0]?.TAX_LABEL}}</span>
              </div>
              <div class="col mr-4 list-right-text">
                ${{ (invoiceData[0]?.TRANSACTION_TAXES ).toFixed(2)}}
              </div>
            </div>
            <div class="row">
              <div class="col ml-4 list-left-text">
                <span class="">Amount Due</span>
              </div>
              <div class="col mr-4 list-right-text">
                ${{(invoiceData[0]?.TRANSACTION_TOTAL).toFixed(2)}} &nbsp; <span
                  *ngIf="invoiceData && invoiceData[0]?.CURRENCY_FLAG == 'CAD'">CAD</span>
                <span *ngIf="invoiceData && invoiceData[0]?.CURRENCY_FLAG == 'USD'">USD</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="divider mt-2"></div>
      <!-- <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between"> -->
      <div class="text-center text-md-center  ">
        <p class="mb-5 mt-1" style="font-size: 0.6rem ; font-weight: 400;"
          *ngIf="invoiceData && invoiceData[0]?.CURRENCY_FLAG == 'USD'">
          All Invoices are due on receipt of service date. <br />
          Please make Check payable to: Alliance Ground International, d.b.a. Airport Butler
        </p>
        <p class="mb-5 mt-1" style="font-size: 0.6rem ; font-weight: 400;"
          *ngIf="invoiceData && invoiceData[0]?.CURRENCY_FLAG == 'CAD'">
          All Invoices are due on receipt of service date. <br />
          Please make Cheque payable to: Alliance Ground International Canadian Company, d.b.a. Airport Butler
          <br />
          <br />
          <span> {{invoiceData[0]?.TAX_LABEL_DESCRIPTION}} </span>
        </p>
      </div>

      <div class="table-responsive mt-5">
        <table class="table table-bordered font-size-xs">
          <thead>
            <tr>
              <th class="tx-right">Reservation #</th>
              <th class="tx-right">Travel Direction</th>
              <th class="tx-right">Travel Date</th>
              <th class="tx-right">Airport Details</th>


            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tx-center">{{invoiceData[0]?.RESID}}</td>
              <td class="tx-right">
                <span *ngIf="invoiceData[0]?.SERVICEDIRECTIONID == 'X' "> Transfer </span>
                <span *ngIf="invoiceData[0]?.SERVICEDIRECTIONID == 'D' "> Departure </span>
                <span *ngIf="invoiceData[0]?.SERVICEDIRECTIONID == 'A' "> Arrival </span>
              </td>
              <td class="tx-right">{{getDate(invoiceData[0]?.STARTDT)}}</td>
              <td class="tx-right">{{invoiceData[0]?.AIRPORT_NAME}}</td>

            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered font-size-xs">
          <thead>
            <tr>
              <th class="tx-right">Meeting Place</th>
              <th class="tx-right">Meeting Time </th>
              <th class="tx-right">Passenger(s) #</th>
              <th class="tx-right">Luggage #</th>
              <th class="tx-right">Pets #</th>
              <th class="tx-right">Optional Tracking</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tx-right">{{invoiceData[0]?.MEETINGPLACE}}</td>
              <td class="tx-right">{{getTimeFormat(invoiceData[0]?.MEETING_TIME)}}</td>
              <td class="tx-right">{{invoiceData[0]?.NUMPAX}}</td>
              <td class="tx-right">{{invoiceData[0]?.NUMBAGS}}</td>
              <td class="tx-right">{{invoiceData[0]?.NUMPETS}}</td>
              <td class="tx-right">{{invoiceData[0]?.OPTTRACKING}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered font-size-xs">
          <thead>
            <tr>
              <th class="tx-right">Flight #</th>
              <th class="tx-right">Airline</th>
              <th class="tx-right">Flight Direction</th>
              <th class="tx-right">Flight Time</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let flight of flightInfo">
              <td class="tx-center">{{flight.FLTNUM}}</td>
              <td class="tx-right">{{flight.COMBINEDNAME}}</td>
              <td class="tx-right">

                <span *ngIf="flight.FLTDIRECTION == 'A' "> Arrival </span>
                <span *ngIf="flight.FLTDIRECTION == 'D' "> Departure </span>
              </td>
              <td class="tx-right">{{getTimeFormat(flight.FLTDATETIME)}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive ">
        <table class="table table-bordered font-size-xs">
          <thead>
            <tr>
              <th class="tx-right">Passenger Name</th>
              <th class="tx-right">PNR</th>
              <th class="tx-right">Phone</th>
              <th class="tx-right">Language</th>
              <th class="tx-right">Email</th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let pass of passengers">
              <td class="tx-center">{{pass.TITLE}} &nbsp; {{pass.FNAME}} {{pass.LNAME}} &nbsp;<span
                  *ngIf="pass.PRIMARYPAX"><small>(Primary)</small></span></td>
              <td class="tx-right">{{pass.PNR}}</td>
              <td class="tx-right">{{pass.PHONE}}</td>
              <td class="tx-right"> {{pass.DESCRIPTION}}</td>
              <td class="tx-right">{{pass.EMAILADDRESS}}</td>

            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive " *ngIf="invoiceData[0]?.OUTSOURCED_STATION == 0">
        <table class="table table-bordered font-size-xs">
          <thead>
            <tr>
              <th class="tx-right">Primary Concierge</th>
              <th class="tx-right">Primary Concierge Phone #</th>
              <th class="tx-right">Secondary Concierge</th>
              <th class="tx-right">Secondary Concierge Phone #</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tx-center">{{invoiceData[0]?.PRIMARY_CONCIERGE}}</td>
              <td class="tx-right">{{invoiceData[0]?.MOBILENO}}</td>
              <td class="tx-right">{{invoiceData[0]?.SECONDARY_CONCIERGE}}</td>
              <td class="tx-right">{{invoiceData[0]?.SECONDARY_MOBILE}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-responsive " *ngIf="invoiceData[0]?.OUTSOURCED_STATION == 1">
        <table class="table table-bordered font-size-xs">
          <thead>
            <tr>
              <th class="tx-right">Outsourced Agency Name</th>
              <th class="tx-right">Outsourced Agency Phone #</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="tx-center">{{invoiceData[0]?.OUTSOURCED_AGENT}}</td>
              <td class="tx-right">{{invoiceData[0]?.OUTSOURCED_AGENT_CONTACT_NUMBER}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row">
        <div class="col">
          <div class="rounded p-3 bg-secondary mb-4">
            <div class="text-uppercase  mb-2 font-size-xs" style="color:#000">
              Notes
            </div>
            <p class="mb-5 mt-1 " style="font-size: 0.7rem ; font-weight: 400;color:#000">
              {{invoiceData[0]?.RESSPECIALNEEDS}}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>
  <notifier-container></notifier-container>